import { render, staticRenderFns } from "./DoctorDashboard.vue?vue&type=template&id=4cff7be0&scoped=true&"
import script from "./DoctorDashboard.vue?vue&type=script&lang=js&"
export * from "./DoctorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DoctorDashboard.vue?vue&type=style&index=0&id=4cff7be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cff7be0",
  null
  
)

export default component.exports